import React from 'react';

const Arrow = ({ style }) => <span style={{ fontSize: 22, ...style }}>→</span>;

export default Arrow;
